var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-duplicate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-duplicate",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "duplicate_120027",
    transform: "translate(4.000000, 3.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,4 L4,2.50100238 C4,1.1202905 5.11928813,0.00100238 6.5,0.00100238 L12.4720225,0.00100238 C12.6047688,-0.00741709 12.7429463,0.03684187 12.8535534,0.14744899 L15.8535534,3.14744899 C15.9641605,3.25805611 16.0084195,3.39623363 16,3.52897986 L16,11.5010024 C16,12.8817143 14.8807119,14.0010024 13.5,14.0010024 L12,14.0010024 L12,15.5 C12,16.8807119 10.8807119,18 9.5,18 L2.5,18 C1.11928813,18 0,16.8807119 0,15.5 L0,6.5 C0,5.11928813 1.11928813,4 2.5,4 L4,4 Z M4,5 L2.5,5 C1.67157288,5 1,5.67157288 1,6.5 L1,15.5 C1,16.3284271 1.67157288,17 2.5,17 L9.5,17 C10.3284271,17 11,16.3284271 11,15.5 L11,14.0010024 L8.5,14.0010024 C8.2238576,14.0010024 8,13.7771448 8,13.5010024 C8,13.22486 8.2238576,13.0010024 8.5,13.0010024 L13.5,13.0010024 C14.3284271,13.0010024 15,12.3294295 15,11.5010024 L15,4.00100238 L12.5,4.00100238 C12.2238576,4.00100238 12,3.77714475 12,3.50100238 L12,1.00100238 L6.5,1.00100238 C5.67157288,1.00100238 5,1.67257525 5,2.50100238 L5,7.5000237 C5,7.7761595 4.77614767,8.0000118 4.50001183,8.0000118 L4.5,8.0000118 C4.22385571,8.0000053 4,7.7761443 4,7.5 L4,5 Z M13,3.00100238 L14.2928932,3.00100238 L13,1.70810916 L13,3.00100238 Z M9.2928932,7 L7.5,7 C7.2238576,7 7,6.77614237 7,6.5 C7,6.22385763 7.2238576,6 7.5,6 L10.5,6 C10.7761424,6 11,6.22385763 11,6.5 L11,9.5 C11,9.7761424 10.7761424,10 10.5,10 C10.2238576,10 10,9.7761424 10,9.5 L10,7.7071068 L4.85355339,12.8535534 C4.65829124,13.0488155 4.34170876,13.0488155 4.14644661,12.8535534 C3.95118446,12.6582912 3.95118446,12.3417088 4.14644661,12.1464466 L9.2928932,7 L9.2928932,7 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDuplicate);
export default __webpack_public_path__ + "static/media/ic-duplicate.e92f10407a4802532f3c620eb0a565f7.svg";
export { ForwardRef as ReactComponent };